/* eslint camelcase: "off" */
import axios, { AxiosError } from "axios";
import { useMutation, useQuery, useQueryClient } from "react-query";
import IntegrationsNotificationConfig, {
  IntegrationsRecipientCandidate,
} from "../model/IntegrationsNotificationConfig";

const URL = "/employer_features_config/integrations_notifications/";
const CANDIDATES_URL = `${URL}recipient_candidates/`;
const QUERY_KEY = "IntegrationsNotificationConfigApiService";
const CANDIDATES_QUERY_KEY = "IntegrationsRecipientCandidatesApiService";

export interface IntegrationsNotificationConfigUpdate {
  schedule: IntegrationsNotificationConfig["schedule"];
  recipient_user_ids: number[];
  recipient_emails: string[];
}

const getIntegrationsNotificationConfig = async (): Promise<IntegrationsNotificationConfig> => {
  const { data } = await axios.get<IntegrationsNotificationConfig>(URL);
  return data;
};

const putIntegrationsNotificationConfig = async (
  body: IntegrationsNotificationConfigUpdate
): Promise<IntegrationsNotificationConfig> => {
  const { data } = await axios.put<IntegrationsNotificationConfig>(URL, body);
  return data;
};

const getIntegrationsRecipientCandidates = async (): Promise<
  IntegrationsRecipientCandidate[]
> => {
  const { data } = await axios.get<IntegrationsRecipientCandidate[]>(CANDIDATES_URL);
  return data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const useIntegrationsNotificationConfig = (enabled = true) =>
  useQuery<IntegrationsNotificationConfig, AxiosError>(
    [QUERY_KEY],
    getIntegrationsNotificationConfig,
    { enabled, keepPreviousData: true }
  );

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const useIntegrationsRecipientCandidates = (enabled = true) =>
  useQuery<IntegrationsRecipientCandidate[], AxiosError>(
    [CANDIDATES_QUERY_KEY],
    getIntegrationsRecipientCandidates,
    { enabled, keepPreviousData: true }
  );

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const useUpdateIntegrationsNotificationConfig = () => {
  const queryClient = useQueryClient();
  return useMutation<
    IntegrationsNotificationConfig,
    AxiosError,
    IntegrationsNotificationConfigUpdate
  >(putIntegrationsNotificationConfig, {
    onSuccess: (data) => {
      queryClient.setQueryData([QUERY_KEY], data);
      queryClient.invalidateQueries([QUERY_KEY]);
    },
  });
};
